import { startOfToday, subYears } from 'date-fns';

type CircuitParticipantCounts = {
  nbAdults: number;
  nbChildren: number;
  nbAdolescents: number;
};

type ChildAgeRange = {
  childAgeFrom?: number;
  childAgeTo?: number;
};

type EstimateChildrenBirthDatesInput = {
  nbChildren: number;
  nbAdolescents: number;
  childrenBirthDates: Record<number, Date>;
  childAgeRanges?: ChildAgeRange[];
};

type CircuitFormParticipantCountInput = {
  nbParticipants?: number;
  nbChildren?: number;
  nbAdolescents?: number;
};

export const getCircuitTotalParticipants = ({
  nbAdults,
  nbChildren,
  nbAdolescents,
}: CircuitParticipantCounts): number =>
  Number(nbAdults) + Number(nbChildren) + Number(nbAdolescents);

export const getEstimateChildrenBirthDatesFromCounts = ({
  nbChildren,
  nbAdolescents,
  childrenBirthDates,
  childAgeRanges,
}: EstimateChildrenBirthDatesInput): Date[] => {
  const fallbackChildAgeFrom = childAgeRanges?.[0]?.childAgeFrom ?? 2;
  const fallbackAdolescentAgeFrom =
    childAgeRanges?.[1]?.childAgeFrom ?? childAgeRanges?.[0]?.childAgeTo ?? 12;
  const fallbackChildBirthDate = subYears(startOfToday(), fallbackChildAgeFrom);
  const fallbackAdolescentBirthDate = subYears(
    startOfToday(),
    fallbackAdolescentAgeFrom,
  );

  return [
    ...Array.from(
      { length: Math.max(0, nbChildren) },
      (_, index) => childrenBirthDates[index] ?? fallbackChildBirthDate,
    ),
    ...Array.from(
      { length: Math.max(0, nbAdolescents) },
      () => fallbackAdolescentBirthDate,
    ),
  ];
};

export const appendCircuitParticipantCountsToFormData = (
  formData: FormData,
  counts: CircuitFormParticipantCountInput,
) => {
  if (counts.nbParticipants != null)
    formData.append('nbParticipants', String(counts.nbParticipants));
  // TODO(circuit-participants-migration): backend `nbAdults` currently stores adolescents in circuit flow.
  if (counts.nbAdolescents != null)
    formData.append('nbAdults', String(counts.nbAdolescents));
  if (counts.nbChildren != null)
    formData.append('nbChildren', String(counts.nbChildren));
};
